import { z } from 'zod';
import { email, optionalText, requiredText } from './common';
import { ALL_PERMISSIONS } from '../permissions';

export const updateStoreDataSchema = z.object({
  name: requiredText(80, 'Informe o nome da loja'),
  legalName: optionalText(120),
  document: optionalText(20),
  stateRegistration: optionalText(30),
  segment: optionalText(40),
  email: email.nullish().or(z.literal('').transform(() => null)),
  phone: optionalText(30),
  whatsapp: optionalText(30),
  zipCode: optionalText(9),
  street: optionalText(120),
  number: optionalText(20),
  complement: optionalText(60),
  district: optionalText(80),
  city: optionalText(80),
  state: optionalText(2),
});
export type UpdateStoreDataInput = z.infer<typeof updateStoreDataSchema>;

export const onboardingUpdateSchema = z.object({
  dismissCard: z.string().max(40).optional(),
  completedTour: z.boolean().optional(),
});

// ---------------------------------------------------------------- Equipe

const permissionKey = z.string().refine((p) => (ALL_PERMISSIONS as string[]).includes(p), 'Permissão inválida');

export const inviteMemberSchema = z.object({
  email,
  role: z.enum(['admin', 'manager', 'seller', 'custom']),
  permissions: z.array(permissionKey).max(50).optional(),
  maxDiscountPercent: z.number().int().min(0).max(100).nullish(),
});
export type InviteMemberInput = z.infer<typeof inviteMemberSchema>;

export const updateMemberSchema = z.object({
  role: z.enum(['admin', 'manager', 'seller', 'custom']).optional(),
  permissions: z.array(permissionKey).max(50).optional(),
  maxDiscountPercent: z.number().int().min(0).max(100).nullish(),
  commissionPercent: z.number().min(0).max(100).nullish(),
  status: z.enum(['active', 'disabled']).optional(),
});
export type UpdateMemberInput = z.infer<typeof updateMemberSchema>;

export const feedbackSchema = z.object({
  type: z.enum(['bug', 'idea', 'question', 'other']).default('other'),
  message: requiredText(4000, 'Escreva sua mensagem'),
  pageUrl: optionalText(500),
});

export const deleteAccountSchema = z.object({
  password: z.string().min(1).max(128),
  confirmation: z.literal('EXCLUIR', { message: 'Digite EXCLUIR para confirmar' }),
  reason: optionalText(500),
});
